import { render, staticRenderFns } from "./SavedFilterList.vue?vue&type=template&id=6b8b6f6f&"
import script from "./SavedFilterList.vue?vue&type=script&lang=js&"
export * from "./SavedFilterList.vue?vue&type=script&lang=js&"
import style0 from "./SavedFilterList.vue?vue&type=style&index=0&id=6b8b6f6f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports